module.exports = "<mat-sidenav-container>\n\n    <div id=\"fuse-main-content\">\n        <mat-progress-bar *ngIf=\"showLoadingBar\" class=\"loading-bar\" color=\"accent\" mode=\"indeterminate\">\n        </mat-progress-bar>\n\n        <div id=\"wrapper\">\n\n\n            <div class=\"content-wrapper\">\n\n                <fuse-content></fuse-content>\n\n            </div>\n\n\n        </div>\n\n    </div>\n\n</mat-sidenav-container>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main